var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoticeYellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 100,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.268 58.023c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 6,
    width: 124,
    height: 85
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.268 58.023c6.25 27.67-29.049 32.813-47.48 31.926-16.126 2.027-52.286 2.508-67.912-11.782-19.533-17.864-.601-57.011 33.355-69.174 33.957-12.162 74.224 14.443 82.037 49.03Z",
    fill: "#FBFBFB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.5 81C80.554 81 96 67.345 96 50.5S80.554 20 61.5 20C42.446 20 27 33.655 27 50.5c0 6.96 2.638 13.377 7.078 18.51-.015.049-.026.1-.034.152L32.216 82.25a1 1 0 0 0 1.366 1.065l12.248-4.96a.987.987 0 0 0 .506-.452C50.912 79.886 56.059 81 61.5 81Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59,
    y: 34,
    width: 6,
    height: 23,
    rx: 3,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 7,
    rx: 3,
    transform: "matrix(1 0 0 -1 59 68)",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 27,
    y1: 24.226,
    x2: 89.738,
    y2: 98.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB8A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoticeYellowIcon);
export default __webpack_public_path__ + "static/media/notice-yellow-icon.6a39160f65049e6c9eecac2f618cde65.svg";
export { ForwardRef as ReactComponent };